import type { Translations } from "../types";

const bn: Translations = {
  "meta.title": "দেশ অনুযায়ী ক্লিক মানচিত্র",
  "meta.description":
    "ইন্টারঅ্যাক্টিভ বিশ্ব মানচিত্র: প্রতিটি দেশের জন্য বিনামূল্যে ক্লিক, এবং Stripe, PayPal ও Buy Me a Coffee-এর মাধ্যমে পেইড সাপোর্টও।",

  "app.title": "দেশ অনুযায়ী ক্লিক মানচিত্র",

  "map.intro":
    "মানচিত্রে কোনো দেশে ক্লিক করে তাকে একটি বিনামূল্যের ভোট দিন, অথবা তাকে আর্থিক সহায়তা পাঠান - উভয়ই নিচের সম্মিলিত লিডারবোর্ডে যোগ হয়। এই মানচিত্র শুধুমাত্র এই অ্যাপের মধ্যে প্রাপ্ত সহায়তা দেখায়, প্রকৃত জাতীয় সম্পদ বা GDP নয়।",
  "map.verifying": "যাচাই করা হচ্ছে …",
  "map.confirmNotRobot": "বিনামূল্যে ক্লিক যোগ করার আগে, দ্রুত নিশ্চিত করুন আপনি রোবট নন:",
  "map.tryAgain": "আবার চেষ্টা করুন",
  "map.registeringClick": "ক্লিক নথিভুক্ত করা হচ্ছে …",
  "map.selectedCountry": "নির্বাচিত দেশ: {name}।",
  "map.selectFirstFeedback": "দেশ নির্বাচিত হয়েছে। বিনামূল্যে ক্লিক যোগ করতে, প্রথমে নিচে নিশ্চিত করুন আপনি রোবট নন।",
  "map.verificationExpired": "যাচাইকরণের মেয়াদ শেষ হয়ে গেছে - আবার নিশ্চিত করুন আপনি রোবট নন।",
  "map.slowDown": "একটু ধীরে - পরের ক্লিকের আগে একটু অপেক্ষা করুন।",
  "map.clickFailed": "ক্লিক নথিভুক্ত করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
  "map.clickErrorGeneric": "ক্লিক নথিভুক্ত করতে ত্রুটি হয়েছে।",
  "map.leaderboardHeading": "দেশ লিডারবোর্ড",
  "map.emptySelection": "ক্লিক করতে বা সহায়তা করতে মানচিত্রে একটি দেশ নির্বাচন করুন।",
  "map.loadingData": "ডেটা লোড হচ্ছে …",

  "worldmap.loadError": "মানচিত্র লোড করা যায়নি।",
  "worldmap.resetZoom": "জুম রিসেট করুন",
  "worldmap.resetButton": "⤾ রিসেট",
  "worldmap.loadingMap": "মানচিত্র লোড হচ্ছে …",
  "worldmap.unknownCountry": "অজানা",
  "worldmap.ariaClicks": "{name}: {clicks}টি ক্লিক",
  "worldmap.tooltipClicks": "{clicks}টি ক্লিক",

  "legend.fewer": "কম ক্লিক",
  "legend.more": "বেশি ক্লিক",

  "list.empty": "এখনও কোনো ক্লিক নেই। প্রথম হোন!",
  "list.ariaLabel": "ক্লিক অনুযায়ী দেশ লিডারবোর্ড",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY সেট করা নেই - কনফিগারেশনের জন্য README দেখুন।",
  "human.verificationFailedGeneric": "যাচাইকরণ ব্যর্থ হয়েছে।",
  "human.networkError":
    "যাচাইকরণ সার্ভিসে পৌঁছানো যায়নি (নেটওয়ার্ক ত্রুটি) - VITE_SUPABASE_URL, verify-human ডিপ্লয় করা হয়েছে কিনা, এবং ALLOWED_ORIGIN যাচাই করুন; বিস্তারিত জানতে README/NAVODILA দেখুন।",
  "human.verificationFailedRetry": "যাচাইকরণ ব্যর্থ হয়েছে, আবার চেষ্টা করুন।",

  "provider.stripe": "💳 কার্ড (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "নির্বাচিত দেশ",
  "panel.currentlyRanked": "বর্তমান র‍্যাঙ্ক #{rank}",
  "panel.shareCopied": "কপি করা হয়েছে ✓",
  "panel.shareShared": "শেয়ার করা হয়েছে ✓",
  "panel.shareButton": "🔗 শেয়ার",

  "panel.tableClicks": "ক্লিক",
  "panel.tableFree": "বিনামূল্যে",
  "panel.tablePaid": "পেইড",
  "panel.rowAllTime": "সর্বমোট",
  "panel.rowThisYear": "এই বছর",
  "panel.rowThisWeek": "এই সপ্তাহ",
  "panel.rowToday": "আজ",

  "panel.totalCombined": "সম্মিলিত মোট:",
  "panel.totalSupport": "মোট সহায়তা:",

  "panel.paymentMethod": "পেমেন্ট পদ্ধতি",
  "panel.noPaymentMethod": "বর্তমানে কোনো পেমেন্ট পদ্ধতি উপলব্ধ নেই।",
  "panel.supportAmount": "সহায়তার পরিমাণ (EUR)",
  "panel.amountRange": "পরিমাণ অবশ্যই {min} এবং {max}-এর মধ্যে হতে হবে।",
  "panel.quickAmount": "€{eur}",
  "panel.estimatedClicks": "আনুমানিক পেইড ক্লিক:",
  "panel.ratioInfo":
    "অনুপাত: {a} = {b} ক্লিক (যেমন {c} = {d} ক্লিক)। এটি পেমেন্টের আগে শুধুমাত্র একটি আনুমানিক হিসাব - চূড়ান্ত ক্লিক সংখ্যা সবসময় সার্ভার দ্বারা প্রকৃতপক্ষে নিশ্চিত হওয়া পেমেন্টের ভিত্তিতে গণনা ও নিশ্চিত করা হয়।",
  "panel.preparing": "প্রস্তুত করা হচ্ছে …",
  "panel.continueWith": "{provider}-এর মাধ্যমে চালিয়ে যান",
  "panel.choosePaymentMethod": "একটি পেমেন্ট পদ্ধতি বেছে নিন",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME সেট করা নেই - কনফিগারেশনের জন্য README দেখুন।",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID সেট করা নেই - কনফিগারেশনের জন্য README দেখুন।",

  "panel.paypalAmountInfo": "পরিমাণ: {amount} (আনুমানিক {clicks}টি ক্লিক)। নিচের PayPal বোতাম দিয়ে পেমেন্ট সম্পূর্ণ করুন।",
  "panel.back": "← ফিরে যান",

  "panel.bmcWarningTitle": "⚠️ BuyMeCoffee-তে যাওয়ার আগে:",
  "panel.bmcWarningBody":
    "চেকআউটের সময় নিচের কোডটি মেসেজ/নোট ফিল্ডে পেস্ট করুন — এটিই একমাত্র উপায় যাতে আমরা জানতে পারি আপনি কোন দেশকে সহায়তা করছেন। কোড ছাড়া, আমরা পেমেন্টটি কোনো দেশের সাথে সম্পর্কিত করতে পারব না।",
  "panel.copy": "কপি করুন",
  "panel.copied": "কপি করা হয়েছে ✓",
  "panel.suggestedAmount": "প্রস্তাবিত পরিমাণ:",
  "panel.bmcAmountNote":
    "(আনুমানিক {clicks}টি ক্লিক)। দুর্ভাগ্যবশত BuyMeCoffee লিঙ্কের মাধ্যমে পরিমাণ পাঠানো সমর্থন করে না — তাদের সাইটে নিজে থেকে পরিমাণ লিখুন বা বেছে নিন। প্রকৃত ক্লিক সংখ্যা সবসময় BuyMeCoffee-তে আপনি প্রকৃতপক্ষে যে পরিমাণ পাঠান তার উপর ভিত্তি করে গণনা করা হয়, এই আনুমানিক হিসাবের উপর নয়।",
  "panel.openBmc": "BuyMeCoffee খুলুন এবং চালিয়ে যান →",
  "panel.waitingProvider": "পেমেন্ট প্রদানকারীর কাছ থেকে পেমেন্ট নিশ্চিতকরণের অপেক্ষা করা হচ্ছে …",
  "panel.waitingConfirmation": "পেমেন্ট নিশ্চিতকরণের অপেক্ষা করা হচ্ছে …",
  "panel.timedOut":
    "যাচাই করতে সময় শেষ হয়ে গেছে। আপনি পেমেন্ট সম্পূর্ণ করে থাকলে, সার্ভার নিশ্চিতকরণ পাওয়ার সাথে সাথেই মানচিত্র আপডেট হবে - এতে কখনো কখনো একটু বেশি সময় লাগতে পারে।",
  "panel.checkAgain": "আবার যাচাই করুন",

  "panel.cancelled": "পেমেন্ট বাতিল হয়েছে বা সম্পূর্ণ হয়নি। মানচিত্রে কোনো পরিবর্তন হয়নি।",
  "panel.tryAgain": "আবার চেষ্টা করুন",

  "panel.confirmed": "✅ সহায়তা নিশ্চিত হয়েছে!",
  "panel.confirmedBody": "{country} {amount}-এর বিনিময়ে {clicks}টি পেইড ক্লিক পেয়েছে।",

  "panel.errorPreparingSupport": "আপনার সহায়তা প্রস্তুত করতে ত্রুটি হয়েছে।",
  "panel.errorPreparingPayment": "পেমেন্ট প্রস্তুত করতে ত্রুটি হয়েছে।",
  "panel.errorConfirmingPayment": "পেমেন্ট নিশ্চিত করতে ত্রুটি হয়েছে।",
  "panel.errorPayingPaypal": "PayPal দিয়ে পেমেন্ট করতে ত্রুটি হয়েছে।",

  "share.unranked": "{flag}{country}-এর বিশ্ব মানচিত্রে আপনার সহায়তা প্রয়োজন!\nএটিকে লিডারবোর্ডে এগিয়ে যেতে সাহায্য করুন 👇",
  "share.rank1": "{flag}{country} বর্তমানে #1 নম্বরে আছে!\nআমাদের শীর্ষে থাকতে সাহায্য করুন 👇",
  "share.rankN": "{flag}{country} বর্তমানে #{rank} নম্বরে আছে!\nআমাদের #1 নম্বরে পৌঁছাতে সাহায্য করুন 👇",

  "language.switcherLabel": "ভাষা",
};

export default bn;
